<template>
  <div class="map-city">
    <div class="map">
      <slot name="tips" />
      <chart-map
        v-bind="$attrs"
        :legendVisible="false"
        :dataEmpty="map.rows && map.rows.length === 0"
        :chartMapSettings="chartMapSettings"
        :chartMapData="map"
        :events="events"
      />
    </div>
    <div class="city-list">
      <div class="switch-btn">
        <el-button
          size="90"
          round
          class="fff-color"
          v-for="(item, index) in btn"
          :key="index"
          :class="activeIndex === index ? 'active' : ''"
          v-html="item.title"
          @click="changeAreaData(item, index)"
        />
      </div>
      <ul>
        <fragment v-if="goodsList.length === 0">
          <li class="item" v-for="(item, index) in map.rows" :key="index">
            <span class="city-name">{{ item['area'] }}</span>
            <span class="num">{{
              Object.values(item).find(v => {
                return !isNaN(v)
              })
            }}</span>
          </li>
        </fragment>
        <fragment v-else>
          <li class="item" v-for="(item, index) in goodsList" :key="index">
            <span class="city-name">{{ item.name }}</span>
            <span class="num"> {{ item.num }}</span>
          </li>
        </fragment>
      </ul>
      <div class="pagination" v-if="pagination.pageTotal >= 1">
        <i @click="changeAreaData('', '', 'left')" class="el-icon-caret-left" />
        <span class="page-number">
          {{ pagination.currentPage }} /
          {{ pagination.pageTotal }}
        </span>
        <i
          @click="changeAreaData('', '', 'right')"
          class="el-icon-caret-right"
        />
      </div>
    </div>
  </div>
</template>
<script>
import chartMap from 'components/Chart/Map/'

export default {
  name: 'MapCity',
  props: {
    chartMapData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    btn: {
      type: Array,
      default: () => []
    },
    changeData: {
      type: Function,
      default: () => {}
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          currentPage: 1,
          pageTotal: -1
        }
      }
    },
    goodsList: {
      type: Array,
      default: () => []
    },
    provinceId: {
      type: String
    },
    events: {
      type: Object
    }
  },
  components: {
    chartMap
  },
  data() {
    return {
      chartMapSettings: {
        position: 'china',
        selectData: true,
        selectedMode: 'single'
        // beforeRegisterMap: json => {
        //   if (this.type === 'city') {
        //     // const currentAddress = ['深圳','珠海','苏州','大同','天津','北京','黄冈']
        //     // json.features = json.features.filter(v => {
        //     //   return currentAddress.includes(v.properties.name)
        //     // })
        //   }
        //   return json
        // }
      },
      activeIndex: 0,
      type: this.btn.length > 0 ? this.btn[0].type : '',
      mode: this.btn.length > 0 ? this.btn[0].mode : ''
    }
  },
  computed: {
    map() {
      const arr = this.chartMapData
      if (arr && arr.rows) {
        arr.rows.forEach(v => {
          if (typeof v['area'] === 'string')
            v['area'] = v['area'].replace(/(市|省|维吾尔|自治区)/g, '')
        })
      }
      return arr
    }
  },
  methods: {
    /**
     * 分页
     * @param item
     * @param index
     * @param directive
     */
    changeAreaData(item, index, directive) {
      if (directive) {
        switch (directive) {
          case 'left':
            this.pagination.currentPage !== 1
              ? (this.pagination.currentPage -= 1)
              : this.$notify({
                  type: 'warning',
                  title: '已经是第一页了~'
                })
            break
          case 'right':
            this.pagination.currentPage < this.pagination.pageTotal
              ? (this.pagination.currentPage += 1)
              : this.$notify({
                  type: 'warning',
                  title: '已经是最后一页了~'
                })
            break
        }
      }
      if (item) {
        this.mode = item.mode
        this.type = item.type
        this.activeIndex = index
        this.pagination.currentPage = 1
      }
      if (this.goodsList.length === 0) {
        this.changeData({
          search_mode: this.mode,
          see_type: this.type,
          curpage: this.pagination.currentPage
        }) //.then(() => {
        //   if (this.type === 'city') {
        //     this.chartMapSettings.position = 'china-cities'
        //   } else {
        //     this.chartMapSettings.position = 'china'
        //   }
        // })
      } else {
        this.changeData({
          province_id: this.provinceId,
          curpage: this.pagination.currentPage
        })
      }
    }
  }
}
</script>
<style lang="scss">
.map-city {
  display: flex;
  align-items: center;
  width: 100%;

  .switch-btn {
    margin-bottom: 1rem;
  }

  .map {
    position: relative;
    text-align: center;
    flex: 1;
    margin-right: 1.3rem;

    .tips {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .city-list {
    position: relative;
    flex: 0.6;
    min-height: 31rem;
  }

  .item {
    display: flex;
    align-items: center;
    height: 3.1rem;
    border-bottom: 1px solid #e1e1e1;
  }

  .city-name,
  .num {
    flex: 1;
  }

  .num {
    text-align: center;
  }

  .pagination {
    margin-top: 1rem;
    bottom: -2rem;
    margin-left: 0;

    i {
      &:before {
        font-size: 15px;
        cursor: pointer;
      }
    }
  }
}
</style>
